import gsap from "gsap"
export class Header {
    constructor() {
        this.header = document.querySelector('header')

        if(!this.header) {
            return
        }

        this.navLink = this.header.querySelectorAll('.nav-link')
        this.linkLvlOne = this.header.querySelectorAll('.level-one-link')
        this.dropDownsLvlThreeBtn = this.header.querySelectorAll('.btn-lvl-three-dropdown')
        this.containerListLvlThree = this.header.querySelectorAll('.container-list-lvl-three')
        this.btnPrevSub = this.header.querySelectorAll('.btn-prev-sub')
        this.btnBurger = this.header.querySelector('.navbar-toggler')
        this.btnClose = this.header.querySelector('.close-button')
        this.overlay = document.querySelector('.overlay')
        this.body = document.querySelector('body')
        
        // MENU
        this.toggleMenu();
        this.hideMenuWithKeyboard();
        this.toggleDropdownsLvlThree();
    }

    /**
     * Open and close the menu on click (or enter then btn is keyboard focuse)
     */
    toggleMenu() {
        this.btnBurger.addEventListener('click', () => {
            
            if(this.header.classList.contains('menu-open')) {
                this.btnBurger.ariaExpanded = 'false'
                this.header.classList.remove('menu-open')
                this.overlay.classList.remove('visible')
                this.body.classList.remove('menu-open')

                
                this.linkLvlOne.forEach(link => {
                    link.classList.contains('-current') === false 
                    ? link.parentElement.classList.remove('active')
                    : link.parentElement.classList.add('active')
                })
            }else {
                this.btnBurger.ariaExpanded = 'true'
                this.overlay.classList.add('visible')
                this.header.classList.add('menu-open')
                this.body.classList.add('menu-open')
                
            }
        })

        // Close menu onclick on the overlay
        this.overlay.addEventListener('click', () => {
            this.btnBurger.ariaExpanded = 'false'
            this.header.classList.remove('menu-open')
            this.overlay.classList.remove('visible')
            this.body.classList.remove('menu-open')
        })

        this.btnClose.addEventListener('click', () => {
            this.btnBurger.ariaExpanded = 'false'
            this.header.classList.remove('menu-open')
            this.overlay.classList.remove('visible')
            this.body.classList.remove('menu-open')
        })
    }

    /**
     * Close menu with using "esc" Keyboard
     */
    hideMenuWithKeyboard() {
        document.addEventListener('keydown', (e) => {
            if(e.keyCode === 27) {
                this.btnBurger.ariaExpanded = 'false'
                this.header.classList.remove('menu-open')
                this.overlay.classList.remove('visible')

                this.linkLvlOne.forEach(link => {
                    link.classList.contains('-current') === false 
                    ? link.parentElement.classList.remove('active')
                    : link.parentElement.classList.add('active')
                })
            }
        })
    }

    toggleDropdownsLvlThree() {
        let mm = gsap.matchMedia();

        this.dropDownsLvlThreeBtn.forEach(btn => {
            btn.addEventListener('click', () => {
                const wrapper = btn.nextElementSibling
                
                const closeAllDropdowns = () => {
                    gsap.to(".container-list-lvl-three", {
                        height: 0,
                        opacity: 0,
                        duration: 0.4,
                        visibility: "hidden",
                        ease: "ease-out"
                    })
                    this.dropDownsLvlThreeBtn.forEach(button => {
                        mm.add("(max-width: 680px)", () => {
                            gsap.to(button, { marginBottom: 0, duration: 0.4})
                        })

                        button.classList.remove('active')
                        button.setAttribute('aria-expanded', 'false')
                    })
                }
              
                if(btn.getAttribute("aria-expanded") === "false") {
                    closeAllDropdowns()
                    gsap.to(wrapper, {
                        height: "auto",
                        opacity: 1,
                        duration: 0.4,
                        visibility: "visible",
                        ease: "ease-out"
                    });
    
                    mm.add("(max-width: 680px)", () => {
                        gsap.to(btn, { marginBottom: "2rem", duration: 0.4})
                    })
                    btn.classList.add('active')
                    btn.setAttribute('aria-expanded', 'true')
                }else {
                    closeAllDropdowns()
                }
            })
        })
    }
}